<template>
	<div>
		<div class="row topbar">
			<div class="col-12">
				<h2>Lot {{selectedLot}}</h2>
				<button v-if="selectedLot > 1" class="button-action" @click="selectedLot -= 1;"><</button>
				<button v-if="board.totalLots > selectedLot" class="button-action" @click="selectedLot += 1;">></button>
			</div>
		</div>
		<table class="grid detailed">
			<thead>
				<tr>
					<th>
						<div class="bar bg-blue rider">
							<h3>Rider</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown lot">
							<h3>Horses</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown lot">
							<h3>Tasks</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown lot">
							<h3>Equipment</h3>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="row in board.totalRows" :key="row" :style="rowStyle(row)">
					<template v-if="showRow(row)">
						<td>
							<Person v-if="board.rows[row] && board.rows[row].person" :person="peopleById[board.rows[row].person]"/>
						</td>
						<td>
							<Horse v-if="board.rows[row] && board.rows[row].lots[selectedLot] && horsesById[board.rows[row].lots[selectedLot]]" :horse="horsesById[board.rows[row].lots[selectedLot]]" :tasks="board.tasks[board.rows[row].lots[selectedLot]]"/>
						</td>
						<td>
							<span v-if="board.rows[row] && board.rows[row].lots[selectedLot]">
								{{ parseTasks(board.tasks[board.rows[row].lots[selectedLot]] || []) }}
							</span>
						</td>
						<td>
							<span v-if="board.rows[row] && board.rows[row].lots[selectedLot]">
								{{ parseEquipment(horsesById[board.rows[row].lots[selectedLot]].equipment) }}
							</span>
						</td>
					</template>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { Container, Draggable } from 'vue-smooth-dnd'
import Horse from '../../Common/Horse.vue'
import Person from '../../Common/Person.vue'
import moment from 'moment'

export default {
	props: ['board', 'locationFilter', 'lots'],
	components: {
		Container,
		Draggable,
		Horse,
		Person
	},
	data() {
		return {
			time: '',
			selectedLot: 1
		}
	},
	computed : {
		...mapState({
			people: state => state.people.list,
			horseList: state => state.horses.list,
			tasks: state => state.tasks.list,
			equipment: state => state.equipment.list
		}),
		peopleById() {
			return this.mapArrayById(this.$store.getters['people/list'], 'id')
		},
		horsesById() {
			return this.mapArrayById(this.horses, 'id')
		},
		tasks() {
			return this.mapArrayById(this.$store.getters['tasks/list'], 'id')
		},
		equipment() {
			return this.mapArrayById(this.$store.getters['equipment/list'], 'id')
		},
		horses() {
			return this.horseList.filter(horse => {
				return this.locationFilter.id === 0 || horse.location_id === this.locationFilter.id	
			})
		}
	},
	methods: {
		parseTasks(ids) {
			if(!ids ||  Object.keys(this.tasks).length === 0) {
				return ''
			} 
			//Maps through ids matching them with the name and then filters out the non unique tasks
			return [...new Set(ids.map(id => this.tasks[id].name))].join(', ');
		},
		parseEquipment(ids) {
			if(Object.keys(this.equipment).length === 0) {
				return ''
			}

			return ids.map(id => {
				return this.equipment[id].name
			}).join(', ')

		},
		checkTime() {
			const format = 'HH:mm'
			this.time = moment.utc().local().format(format)
			const currTime = moment(this.time, format)
			let lotTime = {}
		
			this.lots.forEach(lot => {
				lotTime.start = moment(lot.start_time, format).subtract(30, 'minutes');
				lotTime.end = moment(lot.end_time, format)
				if(currTime.isBetween(lotTime.start, lotTime.end)) {
					this.selectedLot = lot.num
					return
				}
			})
			window.setTimeout(this.checkTime, 60 * 1000)
		},
		showRow(row) {
			return this.rowHasHorse(row)
		},
		rowStyle(row) {
			if(!this.showRow(row)) {
				return {
					display: 'none'
				}
			} else {
				return {}
			}
		},
		rowHasHorse(row) {
			if(this.locationFilter.id === 0) {
				return true
			}
			return this.board.rows[row] && this.board.rows[row].lots[this.selectedLot] && this.horsesById[this.board.rows[row].lots[this.selectedLot]]
		}
	},
	mounted() {
		this.checkTime()
	}
}
</script>

<style lang="scss">
	.topbar {
		h2 {
			margin-left: 3px;
			margin-right: 10px;
			margin-bottom: 0px;
			display: inline-block;
		}
	}
	.grid.detailed {
		border-spacing: 0 10px;
		th {
			width: 25%;
			h3 {
				margin-top: 0px;
			}
		}
		.bar.horse .tasks {
			display: none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Board/Grids/DetailedView.vue